// import React from 'react'
// import './Popup Styles/RadioBtn.css'

// const Radiobtn = (props) => {
//   return (
//     <>
//       <div className="radio">
//           <div style={{display: "flex", alignItems: "center"}}> 
//             <input className='radiobtn' type="radio" name={props.groupName} value={props.name}  id={props.id} onChange={props.onChange}  checked={props.checked}/>
//             <p id='radioname'> {props.name}</p> 
//           </div>
//         <p id='radioprice'>Rs.{props.price}</p>
        
//         </div>
//         <hr className='divider'></hr>


//     </>
//   )
// }

// export default Radiobtn;
import React from 'react';
import './Popup Styles/RadioBtn.css';

const Radiobtn = (props) => {
  const handleDivClick = () => {
    if (!props.checked) {
      props.onChange(true);
    }
  };

  return (
    <>
      <div className="radio" onClick={handleDivClick}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            className="radiobtn"
            type="radio"
            name={props.groupName}
            value={props.name}
            id={props.id}
            checked={props.checked}
            onChange={() => {}}
          />
          <p id="radioname">{props.name}</p>
        </div>
        <p id="radioprice">Rs.{props.price}</p>
      </div>
      <hr className="divider" />
    </>
  );
};

export default Radiobtn;

